<template>
  <div class="rht-view report-allocations report-turnover-alloc-parent">
    <GeminiScrollbar class="my-scroll-bar">
      <div
        class="table-container"
        :style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth}px`}"
      >
        <div class="master-head" ref="masterHeadScroll">
          <!--Loop through the allocation data to set the month-year header-->
          <template v-for="(allocation,index) in allocations">
            <div class="master-head-month" :key="index">
              <h3 class="month-name">{{allocation.monthNameAndYear}}</h3>
            </div>
          </template>
        </div>
        <div class="table-wrapper customer-turnover-alloc-sep">
          <div class="master-table-head-box">
            <div
              class="each-month each-month-header each-month-turnover-header"
              :key="index"
              v-for="(allocation,index) in allocations"
            ></div>
          </div>
          <div class="master-table master-report-table master-table-loaded" v-bar>
            <scroll-sync group="report" vertical>
              <template v-for="(allocation, index) in allocations">
                <div class="report-alloc-tr each-turn-col" :key="index">
                  <div
                    class="each-turn"
                    v-for="(customerTurnovers,turnoverIndex) in allocation.customerTurnovers"
                    :key="turnoverIndex"
                  >
                    <div class="master-table-text right-table-header alloc-value">
                      <p
                        v-if="customerTurnovers.turnover==0"  class="right-td" 
                      >{{customerTurnovers.turnover|money| truncate(9)}}€</p>
                      <p
                        v-else
                        v-tooltip.top-start="`${$options.filters.money(customerTurnovers.turnover)} €`"
                        class="right-td">{{customerTurnovers.turnover|money| truncate(9)}}€</p>
                    </div>
                  </div>
                </div>
              </template>
            </scroll-sync>
          </div>
        </div>
        <!-- Report -->
        <div class="month-report-bottom">
          <div class="report-left-list">
            <template v-for="(result,index) in results">
              <div class="each-turn" :key="index">
                 <p class="right-td">
                  <span v-tooltip.right-start="`${$options.filters.money(result.total.turnOver )} €`">
                  {{result.total.turnOver | money | truncate(9)}}€
                  </span></p>
               
              </div>
            </template>
          </div>
        </div>
      </div>
    </GeminiScrollbar>
  </div>
</template>

<script>
import filters from "../../../../mixins/filters";

export default {
  name: "CustomerTurnoverAllocation",
  mixins: [filters],
  data: () => {
    return {
      masterTableWidth: 0
    };
  },
  computed: {
    allocations: function() {
      return this.$store.state.reports.customerTurnoverAllocations;
    },

    results: function() {
      return this.$store.state.reports.reportAggregate;
    }
  },
  methods: {
    /**
     * Set table width
     */
    setTableWidth: function() {
      setTimeout(() => {
        let element = document.querySelector(
          ".report-allocations .gm-scroll-view"
        );
        if (element) {
          this.masterTableWidth = element.scrollWidth;
        }
      }, 200);
    },

    HeadHorizontalScroll: function() {
      let ScrollElement = this.$refs.masterHeadScroll,
        scrollableElement = document.querySelector(
          ".report-turnover-alloc-parent .gm-scroll-view"
        ),
        i = 0;

      ScrollElement.addEventListener("wheel", function(e) {
        //When dragging to left side
        if (e.deltaY < 0 && !e.shiftKey) {
          if (i >= 0) {
            //if Scroll left == 0
            scrollableElement.scrollLeft = i;
            i = i - 50;
          } else {
            i = 0;
          }
        }

        //Mouse wheel and horizontal scroll for allocation's headers
        else if (e.deltaY > 0 && !e.shiftKey) {
          if (i <= scrollableElement.scrollWidth) {
            //if Scroll left !== end of the div
            scrollableElement.scrollLeft = i;
            i = i + 50;
          } else {
            i = scrollableElement.scrollWidth;
          }
        }
      });
    }
  },
  mounted() {
    setTimeout(() => {
      this.HeadHorizontalScroll();
    }, 500);
  },
  updated() {
    this.setTableWidth();
  }
};
</script>

<style scoped>
.master-head-month,
.master-head-month:first-child {
  width: 190px;
  min-width: 190px;
  text-align: center;
}

.each-turn-col {
  width: 190px;
  min-width: 190px;
}

.master-head-month h3,
.report-allocations .each-turn p {
  text-align: center;
}

.report-allocations .each-turn p {
  padding-top: 16px;
}

.report-allocations .each-turn {
  width: 190px;
  min-width: 190px;
  border-right: 1px solid #dee1e3;
}

.report-allocations .each-month {
  width: 190px;
  min-width: 190px;
  border-right: 1px solid #dee1e3;
}

.master-head-month {
  border-right: 1px solid #dee1e3;
}

.gm-scrollbar.-horizontal {
  bottom: 0;
}

.each-turn {
  border-bottom: 1px solid #dee1e3;
}



.report-left-list .each-turn {
  padding-left: 0;
}

/* Report bottom */
.report-turnover-alloc-parent .month-report-bottom .each-turn {
  border-bottom: none;
  height: 100%;
}

/* Master table on Customer turnover  */
.master-table {
  height: calc(100vh - 253px);
  max-height: calc(100vh - 253px);
  min-height: calc(100vh - 253px);
  border-bottom: 1px solid #dee1e3;
}

.month-report-bottom {
  height: auto !important;
}

.report-allocations .customer-turnover-alloc-sep .each-turn p {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.report-left-list{
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
}
</style>